import { withPermission } from "app/auth/components/withPermission";
import NoAccessScreen from "@shared/components/NoAccessScreen";
import { GroupChannelListScreen } from "../screens/GroupChannelListScreen";
import { GroupChannelCreateScreen } from "../screens/GroupChannelCreateScreen";
import { GroupChannelScreen } from "../screens/GroupChannelScreen";
import { useSendbirdConnection } from '../hooks/useSendbirdConnection';

const ChatScreen = withPermission(
  GroupChannelListScreen,
  'noRestrictions::all',
  { Fallback: NoAccessScreen }
);

const GroupChatScreen = withPermission(
  GroupChannelScreen,
  'noRestrictions::all',
  { Fallback: NoAccessScreen }
);

const GroupChatCreateScreen = withPermission(
  GroupChannelCreateScreen,
  'noRestrictions::all',
  { Fallback: NoAccessScreen }
);

function ChatScreenWrapper() {
  const sendbirdConnection = useSendbirdConnection();
  return <ChatScreen sendbirdConnection={sendbirdConnection} />;
}
function GroupChannelScreenWrapper() {
  const sendbirdConnection = useSendbirdConnection();
  return <GroupChatScreen sendbirdConnection={sendbirdConnection} />;
}
function GroupChannelCreateScreenWrapper() {
  const sendbirdConnection = useSendbirdConnection();
  return <GroupChatCreateScreen sendbirdConnection={sendbirdConnection} />;
}

export {
  ChatScreenWrapper,
  GroupChannelScreenWrapper,
  GroupChannelCreateScreenWrapper
};